<div class="not-secure-wrap mat-body">
    <div class="main">
        <div class="error-template">
            <div class="error-details">
                <p>Formbird needs to be run in a secure context, which is https or localhost (for development). Please see an administrator.</p>
            </div>            
        </div>
    </div>
</div>